import React from 'react'
import { Button } from '../UI/index'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import Backdrop from '@material-ui/core/Backdrop'
import Fade from '@material-ui/core/Fade'

const useStyles = makeStyles(theme => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    borderRadius: 12,
    backgroundColor: '#ffffff',
    outline: 'none',
    width: '304px',
    height: '229px',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  title: {
    width: '240px',
    height: '84px',
    margin: '0 auto',
    marginTop: '41px',
    marginBottom: '24px',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 500,
    fontSize: '20px',
    color: '#000000',
    textAlign: 'center',
  },
  banBtnBox: {
    margin: '0 25px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  btnBack: {
    width: '116px',
    height: '46px',
    border: '1px solid #FC7855',
    color: '#FC7855',
    backgroundColor: '#ffffff',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: '#FC7855',
      color: '#ffffff',
    },
  },
  btnMain: {
    width: '116px',
    height: '46px',
    border: '1px solid #FC7855',
    color: '#ffffff',
    backgroundColor: '#FC7855',
    fontFamily: 'Rubik',
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    borderRadius: '8px',
    '&:hover': {
      backgroundColor: '#EB6D4C',
      color: '#ffffff',
    },
  },
}))

const BanModal = ({ open, setOpen, goTo, onSignUp }) => {
  const classes = useStyles()
  const handleClose = () => setOpen(false)

  return (
    <div>
      <Modal
        aria-labelledby='transition-modal-title'
        aria-describedby='transition-modal-description'
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={open}>
          <div className={classes.paper}>
            <div className={classes.title}>
              Your account has been banned for violating our terms and conditions
            </div>
            <div className={classes.banBtnBox}>
              <Button onClick={onSignUp} className={classes.btnBack}>
                Back
              </Button>
              <Button
                onClick={() => {
                  goTo('/')
                  handleClose()
                }}
                className={classes.btnMain}
              >
                Main page
              </Button>
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  )
}

export default BanModal
